import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Activity, ActivityDeviationStatus } from '@wilson/interfaces';
import { ActivityCardDeviationContentComponent } from './activity-card-deviation-content/activity-card-deviation-content.component';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
@Component({
  selector: 'wilson-activity-card-content',
  template: `
    @if (
      {
        isVisible:
          calculatedActivityWidth && calculatedActivityWidth > MIN_WIDTH_VALUE,
      };
      as data
    ) {
      <div class="content-padding">
        <div class="d-flex justify-content-between">
          <div class="activity-name text-truncate">
            {{ data.isVisible ? activity.name : '' }}
          </div>
          <div class="d-flex">
            @if (activityEndTimeType === ActivityDeviationStatus.Deviated) {
              <wilson-activity-card-deviation-content
                [activityEndTimeType]="activityEndTimeType"
                [activityEndTimeDifference]="activityEndTimeDifference"
              ></wilson-activity-card-deviation-content>
            }
            @if (data.isVisible && hasMismatchedActivityLocations) {
              <div class="activity-location-error">
                <fa-icon [icon]="faExclamationTriangle"></fa-icon>
              </div>
            }
          </div>
        </div>
        <div class="activity-location text-truncate">
          {{ data.isVisible ? activity.startLocation?.locationCode : '' }}
        </div>
      </div>
    }
  `,
  styles: [
    `
      .content-padding {
        padding: 0px 5px;
      }
      .activity-name {
        padding-left: 4px;
        font-size: 10px;
        line-height: 12px;
        font-weight: 400;
        height: 12px;
      }

      .activity-location {
        padding-left: 4px;
        font-size: 12px;
        line-height: 14px;
        font-weight: 500;
        height: 14px;
      }

      .activity-location-error {
        color: var(--red-5);
        padding-right: 4px;
        font-size: 10px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActivityCardDeviationContentComponent, FontAwesomeModule],
})
export class ActivityCardContentComponent {
  @Input() activity!: Activity;
  @Input() calculatedActivityWidth!: number | null;
  @Input() activityEndTimeDifference!: number;
  @Input() activityEndTimeType!: ActivityDeviationStatus;
  @Input() hasMismatchedActivityLocations!: boolean;
  MIN_WIDTH_VALUE = 50;
  faExclamationTriangle = faExclamationTriangle;
  ActivityDeviationStatus = ActivityDeviationStatus;
}
